import { Component, Input, OnInit } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormComponent } from '../../../../../models/FormComponent';
import { Product } from '../../../../../models/Product';
import { ProductValidatorService, ValidationErrorSettings } from "../../../../../services/validators/product-validator.service";

@Component({
  selector: 'app-ape-image-detail',
  templateUrl: './ape-image-detail.component.html',
  styleUrls: ['./ape-image-detail.component.scss']
})
export class ApeImageDetailComponent extends FormComponent implements OnInit {
  @Input('product') product: Product; //assigned a COPY so that original is maintained to check diff.
  @ViewChild('formElement') formElement:ElementRef;
  @ViewChild('formData') formData:NgForm;
  get fieldId():string { return '#'+this.formData.name }
  get fieldValue():string { return this.formData.value as string }

  constructor(
    private _productValidator:ProductValidatorService,
  ) { super() }

  ngOnInit() {
    let validationErrorSettings:ValidationErrorSettings = {fieldNameForMessage:'Filename', required:false, minlength:4}
    this.initParent(this.product, this.formElement, this.formData, this._productValidator, validationErrorSettings);
  }



}



//=================
//Unused Code


// onFormBlur($e){
//   let fieldValue = $e.target.value as string;
//   this.onFormChange(fieldValue);
// }


// onFormChange($e){
//   let fieldId = '#'+this.form.name;  //eg, 'apeSku'
//   let fieldValue = $e as string;

//   //Validate field value
//   let fieldNameForMessage = 'Filename', required=true, minlength=5;
//   let result = this.validator.fieldValidator(fieldId, fieldValue, fieldNameForMessage, required, minlength);

//   // Form errors, only show after initial blur
//   let errorElementId = fieldId+'Error';
//   if(this.form.touched && result.success == false){
//     $(errorElementId).html(result.message);
//     $(errorElementId).show();
//   } else {
//     $(errorElementId).hide();
//   }
// }


// WEBPACK FOOTER //
// ./src/app/components/admin/admin-products/admin-product-edit/ape-image-detail/ape-image-detail.component.ts